document.addEventListener('DOMContentLoaded', function() {
  const statusSelects = document.querySelectorAll('.js-status-select');

  // Color-coded attendance statuses
  statusSelects.forEach(statusSelect => {
    addColorsToStatusSelect(statusSelect);
  });

  const allPresentButtons = document.querySelectorAll('.js-all-present-button');

  allPresentButtons.forEach(button => {
    const statuses = button.closest('table').querySelectorAll('.js-status-select');

    button.addEventListener('click', e => {
      statuses.forEach(select => {
        select.value = 'is_present';

        // Need to manually dispatch the event so the colors change
        select.dispatchEvent(new Event('change'));
      });
    });
  });
});

const addColorsToStatusSelect = (statusSelect) => {
  let val = statusSelect.value;
  statusSelect.classList.add(`status-select--${val}`);

  statusSelect.addEventListener('change', e => {
    statusSelect.className = statusSelect.className.replace(/status-select--[a-z_]+/, `status-select--${e.target.value}`);
  });
};

document.addEventListener('cocoon:before-remove', ({ detail: { removedItem } }) => {
  for(const field of removedItem.querySelectorAll('[data-cocoon-toggle-when-removed]')) {
    field.value = 'true';
  }
});

$(document).on('cocoon:before-insert', (event, insertedItem) => {
  const statusSelect = insertedItem.find('.js-status-select')[0];
  if (!statusSelect) return;

  addColorsToStatusSelect(statusSelect);

  const role = insertedItem.find('.day_staff_attendance_records_role input').val();
  const menu = document.querySelector('.js-add-sub-menu');
  const button = document.querySelector('.js-add-sub-button');
  
  menu.querySelector(`[data-role=${role}]`).classList.add('d-none');

  // If all the submenu items are hidden, hide the button, too
  if (menu.querySelectorAll('.d-none').length === menu.children.length) {
    button.classList.add('d-none');
  }
})

$(document).on('cocoon:before-remove', (event, removedItem) => {
  for(const field of removedItem.find('[data-cocoon-toggle-when-removed]')) {
    field.value = 'true';
  }

  const roleInput = removedItem.find('.day_staff_attendance_records_role input');
  if (!roleInput.length) return;

  const role = roleInput.val();
  document.querySelector('.js-add-sub-button').classList.remove('d-none');
  document.querySelector(`.js-add-sub-menu [data-role=${role}]`).classList.remove('d-none');
});
